import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IonButton, IonIcon } from '@ionic/angular/standalone';

@Component({
  selector: 'app-round-image-clear-button',
  templateUrl: './round-image-clear-button.component.html',
  styleUrls: ['./round-image-clear-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, IonButton, IonIcon]
})
export class RoundImageClearButtonComponent {
  @Input() buttonText: string;
  @Input() href: string;
  @Input() image: string;
  @Input() icon: string;
  @Input() fallbackIcon: string;
  @Input() topSeparator: boolean;
  @Input() bottomSeparator: boolean;
  @Input() chevron: boolean;

  constructor(public sanitizer: DomSanitizer) {}

  hideFallbackIcon(): void {
    this.fallbackIcon = null;
  }

  setToFallbackIcon(): void {
    if (this.fallbackIcon) {
      this.image = null;
    }
  }
}
